import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

/**
 * Lets API requests bypass the Angular service worker.
 *
 * ngsw does not cache API responses (no dataGroups, almost all calls are POST), but it would still
 * intercept every request and pass it through. With `ngsw-bypass` the browser sends it directly.
 * Query parameter instead of header: a custom header would trigger a CORS preflight for the
 * cross-origin API. The API ignores the parameter.
 */
export const ngswBypassInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }
  return next(req.clone({ setParams: { 'ngsw-bypass': 'true' } }));
};
